import { useThemeStore } from '@/stores/theme';

/** BO theme toggle. Drives the `.dark` class on the AppShell root. */
export function ThemeToggle() {
  const theme = useThemeStore((s) => s.theme);
  const toggle = useThemeStore((s) => s.toggle);
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      title="Cambiar tema del backoffice"
      onClick={toggle}
      className="flex cursor-pointer items-center gap-[6px] rounded-[7px] border border-c-line px-[10px] py-[6px] font-mono text-[9px] uppercase tracking-[.6px] text-c-mid transition-colors hover:text-c-text"
    >
      <span
        className="h-[7px] w-[7px] rounded-full"
        style={{ background: isDark ? '#1fd39a' : '#0e9e6e' }}
      />
      {isDark ? 'Dark' : 'Light'}
    </button>
  );
}
